import axios from "axios"

export default {
    namespaced: true,

    state: {
        questions: [],
        tags: []
    },
    mutations: {
        setQuestions(state, array){
            state.questions = array
        },
        setTags(state, array){
            state.tags = array
        }
    },
    actions: {
        fetchData(context){
            axios({
                method: "post",
                data: {
                    query: `{
                        questions: entries(section: "questions"){
                            id,
                            title
                            ... on questions_questions_Entry {
                                text,
                                tags {
                                    id,
                                    title
                                }
                            }
                        }
                    }`
                }
            }).then(function(res){
                context.commit('setQuestions', res.data.data.questions)
            })

            axios({
                method: "POST",
                data: {
                    query: `{
                        tags(group: "questions"){
                            id,
                            title
                        }
                    }`
                }
            }).then(function(res){
                context.commit('setTags', res.data.data.tags)
            })

        }
    },
    getters: {}
}